import { getDefaultStore } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const oauthCallbackDateAtom = atomWithStorage<number>(
  "oauthCallbackDate",
  0
);

export const isInOauthFlow = () => {
  const store = getDefaultStore();
  const oauthCallbackDate = store.get(oauthCallbackDateAtom);
  return Date.now() - oauthCallbackDate < 1000 * 60 * 3;
};
